import { Lock } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { CreatableTags } from '@travelity/form';
import { useTranslation } from 'react-i18next';

const PackageBookingNotesSelection = () => {
    const { t } = useTranslation('product');

    return (
        <CreatableTags
            name="notes"
            renderIcon={({ type }) =>
                type === 'internal' ? (
                    <Tooltip title={t('Internal')}>
                        <Lock />
                    </Tooltip>
                ) : null
            }
            inputProps={{
                label: t('Notes'),
                placeholder: t('Type and press enter to add note'),
            }}
            options={[
                {
                    value: 'internal',
                    label: t('internal'),
                },
                {
                    value: 'customer',
                    label: t('customer'),
                },
            ]}
            defaultOption="internal"
            chipDirection="column"
            chipSx={{
                borderRadius: '12px',
                padding: '8px',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '10px',
                bgcolor: '#F4F6FA',
                '& > .MuiChip-label': {
                    color: '#2B395B',
                    fontSize: '12px',
                    flexGrow: 2,
                    whiteSpace: 'wrap',
                },
                '& > .MuiChip-icon ': {
                    color: '#2B395B',
                },
            }}
        />
    );
};

export default PackageBookingNotesSelection;
